import { Link } from "react-router-dom";
import { Linkedin, Twitter, Youtube, Instagram } from "lucide-react";
import { companies } from "../../data/content";

const explore = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/companies", label: "Our Companies" },
  { to: "/solutions", label: "Solutions" },
  { to: "/insights", label: "Insights" },
  { to: "/partnerships", label: "Partnerships" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

const socials = [
  { icon: Linkedin, label: "LinkedIn", testId: "social-linkedin" },
  { icon: Twitter, label: "X (Twitter)", testId: "social-twitter" },
  { icon: Youtube, label: "YouTube", testId: "social-youtube" },
  { icon: Instagram, label: "Instagram", testId: "social-instagram" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink px-6 pt-24 lg:px-12" data-testid="site-footer">
      <p className="select-none text-[22vw] font-extrabold leading-[0.8] tracking-tighter text-white/[0.04] lg:text-[13rem]">
        HAPO<span className="text-gold/20">.</span>
      </p>

      <div className="mt-4 grid gap-12 border-t border-white/10 pt-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center" data-testid="footer-logo" aria-label="Hapo Group home">
            <img src="/assets/logos/hapo-white.webp" alt="Hapo Group" className="only-dark-theme h-8 w-auto" />
            <img src="/assets/logos/hapo.webp" alt="Hapo Group" className="only-light-theme h-8 w-auto" />
          </Link>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-smoke">
            A South African holding company growing nine operating companies into a significant multi-sector group.
          </p>
          <div className="mt-8 flex gap-3">
            {socials.map(({ icon: Icon, label, testId }) => (
              <a
                key={testId}
                href="#"
                aria-label={`${label} (placeholder)`}
                data-testid={testId}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="Explore">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-gold">Explore</p>
          <ul className="mt-6 space-y-3">
            {explore.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Companies">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-gold">Companies</p>
          <ul className="mt-6 space-y-3">
            {companies.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/companies/${c.slug}`}
                  data-testid={`footer-${c.slug}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-white"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-gold">Contact</p>
          <ul className="mt-6 space-y-3 text-sm text-white/70">
            <li>1 Bridgeway Road, Bridgeway Precinct, Century City, Cape Town</li>
            <li>
              <a href="tel:+27780802462" className="transition-colors duration-300 hover:text-white">
                +27 78 080 2462
              </a>
            </li>
            <li>
              <a href="mailto:info@hapogroup.co.za" className="transition-colors duration-300 hover:text-white">
                info@hapogroup.co.za
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 py-8">
        <p className="text-xs text-smoke">© 2026 Hapo Group (Pty) Ltd. All rights reserved.</p>
        <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-smoke">Built in South Africa</p>
      </div>
    </footer>
  );
}
